import api from './api';

export interface HiringFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  linkedin: string;
  positionName: string;
  cvBase64?: string;
  cvFileName?: string;
}

export const hiringService = {
  submitApplication: async (formData: HiringFormData): Promise<void> => {
    await api.post('hiring', { json: formData });
  },
};
